import Header from "../components/Header";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import Manifesto from "../components/Manifesto";
import Gallery from "../components/Gallery";
import Team from "../components/Team";
import TrustUs from "../components/TrustUs";
import Reviews from "../components/Reviews";
import Services from "../components/Services";
import ServiceMap from "../components/ServiceMap";
import Footer from "../components/Footer";
import TextUsButton from "../components/TextUsButton";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative">
      <Header />
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Gallery />
      <Team />
      <TrustUs />
      <Reviews />
      <Services />
      <ServiceMap />
      <Footer />
      <TextUsButton />
    </main>
  );
}
